module.exports = __webpack_public_path__ + "media/images/riders/MARINE_CABIROU-fee1f8ba1611cea92e2eb02b633cef09.png";